import React, { useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import UserProfileSidebar from "../Components/UserProfileSidebar";
import Footer from "../Components/Footer";
import { Link, useNavigate } from "react-router-dom";
import UserConsultationTab from "../Components/UserConsultationTab";
import { chat, consultantmage, file } from "../Constant/Index";
import { useSelector } from "react-redux";
import { patientPlaceorder } from "../network/Network";
import Swal from "sweetalert2";

const UserBillingDetail = () => {
	const orderdetail = useSelector((state) => state?.Auth?.orderdetail);
	const nearpharmacy = useSelector((state) => state?.Auth?.nearpharmcacy);
	const prescriptiondetail = useSelector(
		(state) => state?.Auth?.prescriptiondetail,
	);
	const token = useSelector((state) => state?.Auth?.token);

	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [formErrors, setFormErrors] = useState([]);
	const [userData, setUserData] = useState({
		first_name: "",
		last_name: "",
		phone: "",
		email: "",
		city: "",
		state: "",
		zip_code: "",
		country: "",
		address: "",
	});

	//   Input Handler
	function handleChange(e) {
		const value = e.target.value;
		setUserData({ ...userData, [e.target.name]: value });
	}
	// ================

	// Placeholder Handler
	// const PlaceholderHandler = (e) => {
	// 	e.preventDefault();
	// 	setLoading(true);

	// 	if (prescriptiondetail?.prescription?.id == null) {
	// 		Swal.fire({
	// 			position: "center",
	// 			icon: "error",
	// 			text: "There is no prescription kindly go back",
	// 			showConfirmButton: false,
	// 			timer: 2000,
	// 		});
	// 		navigate(
	// 			`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`,
	// 		);
	// 		setLoading(false);
	// 	} else {
	// 		let isValid = true;
	// 		const errors = {};

	// 		// Validate First Name
	// 		if (!userData || !userData.first_name) {
	// 			if (!errors || !errors.first_name) {
	// 				if (!errors) errors = {};
	// 				errors.first_name = [];
	// 			}
	// 			errors.first_name.push("First Name is required");
	// 			isValid = false;
	// 		}
	// 		// Validate Last Name
	// 		if (!userData || !userData.last_name) {
	// 			if (!errors || !errors.last_name) {
	// 				if (!errors) errors = {};
	// 				errors.last_name = [];
	// 			}
	// 			errors.last_name.push("Last Name is required");
	// 			isValid = false;
	// 		}

	// 		// Validate Phone Number
	// 		if (!userData || !userData.phone) {
	// 			if (!errors || !errors.phone) {
	// 				if (!errors) errors = {};
	// 				errors.phone = [];
	// 			}
	// 			errors.phone.push("Phone is required");
	// 			isValid = false;
	// 		} else if (userData.phone.length < 8 || userData.phone.length > 10) {
	// 			if (!errors || !errors.phone) {
	// 				if (!errors) errors = {};
	// 				errors.phone = [];
	// 			}
	// 			errors.phone.push("Phone number must be between 8 to 10 digits");
	// 			isValid = false;
	// 		}

	// 		// Validate Email
	// 		if (!userData || !userData.email) {
	// 			if (!errors || !errors.email) {
	// 				if (!errors) errors = {};
	// 				errors.email = [];
	// 			}
	// 			errors.email.push("Email is required");
	// 			isValid = false;
	// 		} else if (!/\S+@\S+\.\S+/.test(userData.email)) {
	// 			if (!errors || !errors.email) {
	// 				if (!errors) errors = {};
	// 				errors.email = [];
	// 			}
	// 			errors.email.push("Email is invalid");
	// 			isValid = false;
	// 		}

	// 		if (!userData || !userData.address) {
	// 			if (!errors || !errors.address) {
	// 				if (!errors) errors = {};
	// 				errors.address = [];
	// 			}
	// 			errors.address.push("address is required");
	// 			isValid = false;
	// 		}

	// 		// Validate country
	// 		if (!userData || !userData.country) {
	// 			if (!errors || !errors.country) {
	// 				if (!errors) errors = {};
	// 				errors.country = [];
	// 			}
	// 			errors.country.push("country is required");
	// 			isValid = false;
	// 		}

	// 		// Validate city
	// 		if (!userData || !userData.city) {
	// 			if (!errors || !errors.city) {
	// 				if (!errors) errors = {};
	// 				errors.city = [];
	// 			}
	// 			errors.city.push("city is required");
	// 			isValid = false;
	// 		}
	// 		// Validate zip_code
	// 		if (!userData || !userData.zip_code) {
	// 			if (!errors || !errors.zip_code) {
	// 				if (!errors) errors = {};
	// 				errors.zip_code = [];
	// 			}
	// 			errors.zip_code.push("zipcode is required");
	// 			isValid = false;
	// 		} else if (userData.zip_code.length < 5) {
	// 			if (!errors || !errors.zip_code) {
	// 				if (!errors) errors = {};
	// 				errors.zip_code = [];
	// 			}
	// 			errors.zip_code.push("zip must be 5 digits");
	// 			isValid = false;
	// 		}

	// 		// Validate state
	// 		if (!userData || !userData.state) {
	// 			if (!errors || !errors.state) {
	// 				if (!errors) errors = {};
	// 				errors.state = [];
	// 			}
	// 			errors.state.push("state is required");
	// 			isValid = false;
	// 		}
	// 		setFormErrors(errors);

	// 		let data = {
	// 			prescription_id: prescriptiondetail?.prescription?.id,
	// 			order_type: "delivery",
	// 			first_name: userData?.first_name,
	// 			last_name: userData?.last_name,
	// 			email: userData?.email,
	// 			phone: userData?.phone,
	// 			city: userData?.city,
	// 			state: userData?.state,
	// 			zip_code: userData?.zip_code,
	// 			country: userData?.country,
	// 			address: userData?.address,
	// 			payment_method: "cod",
	// 			pharmacy_id: nearpharmacy?.nearest_pharmacy?.id,
	// 		};

	// 		patientPlaceorder(data, token)
	// 			.then((res) => {
	// 				setFormErrors([]);

	// 				Swal.fire({
	// 					position: "center",
	// 					icon: "success",
	// 					title: "Your order Has been Placed",
	// 					showConfirmButton: false,
	// 					timer: 1500,
	// 				});
	// 				navigate("/user-thankyou");
	// 				setLoading(false);
	// 			})
	// 			.catch((err) => {
	// 				setFormErrors([]);
	// 				const errorData = err?.response?.data?.errors;

	// 				if (errorData) {
	// 					Object.values(errorData)
	// 						.flat()
	// 						.forEach((message) => {
	// 							Swal.fire({
	// 								position: "center",
	// 								icon: "error",
	// 								text: message,
	// 								showConfirmButton: false,
	// 								timer: 2200,
	// 							});
	// 						});
	// 				}
	// 				setLoading(false);
	// 			});
	// 	}
	// };
	const PlaceholderHandler = (e) => {
		e.preventDefault();
		setLoading(true);

		if (!prescriptiondetail?.prescription?.id) {
			Swal.fire({
				position: "center",
				icon: "error",
				text: "There is no prescription kindly go back",
				showConfirmButton: false,
				timer: 2000,
			});
			navigate(
				`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`,
			);
			setLoading(false);
			return; // ✅ stop further execution
		}

		let isValid = true;
		const errors = {};

		// Validate First Name
		if (!userData?.first_name) {
			errors.first_name = ["First Name is required"];
			isValid = false;
		}

		// Validate Last Name
		if (!userData?.last_name) {
			errors.last_name = ["Last Name is required"];
			isValid = false;
		}

		// Validate Phone
		if (!userData?.phone) {
			errors.phone = ["Phone is required"];
			isValid = false;
		} else if (userData.phone.length < 8 || userData.phone.length > 10) {
			errors.phone = ["Phone number must be between 8 to 10 digits"];
			isValid = false;
		}

		// Validate Email
		if (!userData?.email) {
			errors.email = ["Email is required"];
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(userData.email)) {
			errors.email = ["Email is invalid"];
			isValid = false;
		}

		// Validate Address
		if (!userData?.address) {
			errors.address = ["Address is required"];
			isValid = false;
		}

		// Validate Country
		if (!userData?.country) {
			errors.country = ["Country is required"];
			isValid = false;
		}

		// Validate City
		if (!userData?.city) {
			errors.city = ["City is required"];
			isValid = false;
		}

		// Validate State
		if (!userData?.state) {
			errors.state = ["State is required"];
			isValid = false;
		}

		// Validate Zip Code
		if (!userData?.zip_code) {
			errors.zip_code = ["Zip Code/Postal Code is required"];
			isValid = false;
		} else if (userData.zip_code.length < 5) {
			errors.zip_code = ["Zip Code/Postal Code must be 5 digits"];
			isValid = false;
		}

		setFormErrors(errors);

		if (!isValid) {
			setLoading(false);
			return; // ✅ Don't proceed if invalid
		}

		const data = {
			prescription_id: prescriptiondetail?.prescription?.id,
			order_type: "delivery",
			first_name: userData?.first_name,
			last_name: userData?.last_name,
			email: userData?.email,
			phone: userData?.phone,
			city: userData?.city,
			state: userData?.state,
			zip_code: userData?.zip_code,
			country: userData?.country,
			address: userData?.address,
			payment_method: "cod",
			pharmacy_id: nearpharmacy?.nearest_pharmacy?.id,
		};

		patientPlaceorder(data, token)
			.then((res) => {
				setFormErrors([]);
				Swal.fire({
					position: "center",
					icon: "success",
					title: "Your order has been placed",
					showConfirmButton: false,
					timer: 1500,
				});
				navigate("/user-thankyou");
				setLoading(false);
			})
			.catch((err) => {
				setFormErrors([]);
				const errorData = err?.response?.data?.errors;
				if (errorData) {
					Object.values(errorData)
						.flat()
						.forEach((message) => {
							Swal.fire({
								position: "center",
								icon: "error",
								text: message,
								showConfirmButton: false,
								timer: 2200,
							});
						});
				}
				setLoading(false);
			});
	};

	// ===================

	return (
		<>
			<Header />
			<PageHeader pagename="User Profile" />
			<section className="main-sidebar user-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<UserProfileSidebar />
						</div>
						<div className="col-lg-8">
							<div className="main-profile-content radius-20 p-4">
								<div className="row">
									<div className="col-lg-12">
										<div className="main-headind d-flex align-items-center extra-bg-14 radius-20 dark-color gap-4 p-4 mb-3">
											<div className="edit-btn back">
												<Link
													to={`/consultation-detail/${orderdetail?.booking_detail?.booking_id}`}
												>
													<div className="nav-anchor">
														<i className="fa-solid fa-arrow-left"></i>
													</div>
												</Link>
											</div>
											<div className="content-qty   ">
												<div className="d-flex gap-3 align-items-center">
													<img
														src={
															orderdetail?.physician_detail?.profile_image_url
																? orderdetail?.physician_detail
																		?.profile_image_url
																: consultantmage
														}
														className="img-fluid profie_img"
														alt=""
													/>
													<div>
														<h4 className="main-heading-font level-6 ">
															{orderdetail?.physician_detail?.title}
														</h4>
														<h5 className="primary-medium-font level-8 extra-color-15">
															Physician
														</h5>
														<h4 className="primary-medium-font level-7 ">
															<span className="icon-point">
																<i className="fa-solid fa-location-dot"></i>
															</span>{" "}
															{orderdetail?.physician_detail?.address}
														</h4>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty extra-bg-14 radius-20 p-4 dark-color">
											<form>
												<h4 className="main-heading-font level-6 mb-3">
													Billing Details
												</h4>
												<div className="row">
													<div className="form-group col-lg-6">
														<input
															type="text"
															className="form-control"
															id="firstName"
															placeholder=" First Name"
															name="first_name"
															onChange={handleChange}
															value={userData?.first_name}
														/>
														<p className="forms-error">
															{formErrors?.first_name}
														</p>
													</div>
													<div className="form-group col-lg-6">
														<input
															type="text"
															className="form-control"
															id="lastName"
															placeholder=" Last Name"
															name="last_name"
															onChange={handleChange}
															value={userData?.last_name}
														/>
														<p className="forms-error">
															{formErrors?.last_name}
														</p>
													</div>
												</div>
												<div className="form-group col-lg-12 mb-3">
													<input
														type="email"
														className="form-control"
														id="email"
														placeholder="Enter email"
														name="email"
														value={userData?.email}
														onChange={handleChange}
													/>
													<p className="forms-error">{formErrors?.email}</p>
												</div>
												<div className="form-group col-lg-12">
													<input
														type="tel"
														className="form-control"
														id="phone"
														placeholder=" phone number"
														name="phone"
														value={userData?.phone}
														onChange={handleChange}
													/>
													<p className="forms-error">{formErrors?.phone}</p>
												</div>
												<h4 className="main-heading-font level-6 mb-3 mt-3">
													Address
												</h4>
												<div className="row">
													<div className="form-group col-lg-12">
														<input
															type="text"
															className="form-control"
															id="phone"
															placeholder=" Address"
															name="address"
															value={userData?.address}
															onChange={handleChange}
														/>
														<p className="forms-error">{formErrors?.address}</p>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="text"
															className="form-control"
															id="phone"
															placeholder=" City"
															name="city"
															value={userData?.city}
															onChange={handleChange}
														/>
														<p className="forms-error">{formErrors?.city}</p>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="text"
															className="form-control"
															id="phone"
															placeholder="State"
															name="state"
															value={userData?.state}
															onChange={handleChange}
														/>
														<p className="forms-error">{formErrors?.state}</p>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="text"
															className="form-control"
															id="country"
															placeholder="Country"
															name="country"
															value={userData?.country}
															onChange={handleChange}
														/>
														<p className="forms-error">{formErrors?.country}</p>
													</div>
													<div className="form-group col-lg-3">
														<input
															type="number"
															className="form-control"
															id="phone"
															placeholder=" Zip Code/Postal Code "
															name="zip_code"
															value={userData?.zip_code}
															onChange={handleChange}
														/>
														<p className="forms-error">
															{formErrors?.zip_code}
														</p>
													</div>
												</div>
											</form>
										</div>
									</div>
								</div>
								<div className="row mt-3">
									<div className="col-lg-12">
										<div className="content-qty d-flex align-items-center justify-content-between extra-bg-14 radius-20 p-4 dark-color">
											<h4>Payment Method</h4>
											<h4>Cash on Delivery</h4>
										</div>
									</div>
								</div>
								<div className="row mt-2">
									<div className="col-lg-12">
										<div className="d-flex align-items-center gap-3">
											<Link className="btn wrapper-btn-main w-100 log-in mt-2 level-7 primary-regular-font text-decoration-none">
												<span
													onClick={(e) => PlaceholderHandler(e)}
													className="loading-btn loading bg-wrapper w-100"
												>
													{loading ? (
														<i className="fa fa-spinner"></i>
													) : (
														"Place Order"
													)}
												</span>
											</Link>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default UserBillingDetail;
